import { styled } from 'styled-components';
import { TypographyComponent } from '@tvg/fuse-design';

export const DialogSection = styled.section`
  margin-bottom: var(--spacing-space16);

  &:last-child {
    margin-bottom: 0;
  }
`;

export const DialogHeading = styled(TypographyComponent)`
  margin-bottom: var(--spacing-space12);
`;

export const DialogText = styled(TypographyComponent)`
  strong {
    color: var(--color-greys-grey10);
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const DialogList = styled.ul`
  list-style-type: square;
  padding-left: var(--spacing-space16);
`;
